import React from "react";

export default function EditorGroup({ title, subtitle, defaultOpen = true, right, children }) {
  return (
    <details open={defaultOpen} className="rounded-2xl border border-gray-200 bg-white">
      <summary className="cursor-pointer select-none list-none px-4 py-3 flex items-start justify-between gap-3">
        <div>
          <div className="text-sm font-semibold text-gray-900">{title}</div>
          {subtitle ? <div className="text-xs text-gray-500 mt-0.5">{subtitle}</div> : null}
        </div>

        <div className="flex items-center gap-3">
          {right ? <div onClick={(e) => e.preventDefault()}>{right}</div> : null}
          <div className="text-xs text-gray-400 mt-0.5">Toggle</div>
        </div>
      </summary>

      <div className="px-4 pb-4 pt-1">{children}</div>
    </details>
  );
}